import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  bet,
  rank,
  quiz,
}

export interface RecordsItem {
  time: string
  content: string
  bet_cnt: number
  bonus: string
}

export interface RankItem {
  zy_id: string
  mid: number
  rank: number
  name: string
  avatar: string
  win_cnt: number
}

export interface OptionItem {
  img: string
  // 0 未结束 1  赢了 2 输了
  is_win: 0 | 1 | 2
  link: string
  // 我赢钱
  my_bet_cnt: number
  // 我的下注
  my_win_cnt: number
  // 队伍名称
  name: 'RCB'
  // 下注后得到extra coins
  odds: string
  option_id: number
  // 该队的总钱数目
  total_bet_cnt: number

  // 多少人数
  winner_cnt: number
  // 赢了金币数
  win_cnt: number
}
export interface HomePageData {
  // Pk 日期 serp.19
  content: string
  // 倒计时
  duration: number
  et: number
  et_date: string
  // 轮次id
  game_id: number
  options: Array<OptionItem>
  st: number
  st_date: string
  // 0；竞猜中 1；停止竞猜(封盘) 2；结果已出
  status: 0 | 1 | 2
}

export interface IndianIPLSt {
  canBet: boolean
  currentGameId: number
  currentGame: HomePageData
  homePageData: Array<HomePageData>
  rankPageData: {
    list: Array<RankItem>
    my_info: RankItem
  }
  betRecordsData: {
    list: Array<RecordsItem>
    offset: number
    more: boolean
    my_info: {
      bet_cnt: number
      bet_coins: number
      win_cnt: number
      win_coins: number
    }
  }
}

const initialState: IndianIPLSt = {
  // 是否能够去下注
  canBet: false,
  currentGameId: 0,
  currentGame: {
    content: '',
    // 倒计时
    duration: 0,
    et: 0,
    et_date: '',
    // 轮次id
    game_id: 0,
    options: [],
    st: 0,
    st_date: '',
    // 0；竞猜中 1；停止竞猜(封盘) 2；结果已出
    status: 0,
  },
  homePageData: [],
  rankPageData: {
    list: [],
    my_info: {
      zy_id: '',
      mid: 0,
      rank: 1,
      name: '',
      avatar: '',
      win_cnt: 0,
    },
  },
  betRecordsData: {
    list: [],
    my_info: {
      bet_cnt: 0,
      bet_coins: 0,
      win_cnt: 0,
      win_coins: 0,
    },
    offset: 0,
    more: true,
  },
}

// 首页竞猜信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21642260
export const getHomePageData = createAsyncThunk(
  'IndianIPL/getHomePageData',
  async (arg, store) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/live/activity/cricket_homepage',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

// 排行榜 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21642560
export const getRankList = createAsyncThunk(
  'IndianIPL/getRankList',
  async (arg, store) => {
    const resp = await http.post(
      '/live/activity/cricket_rank',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

// 下注记录 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=21642558
export const getBetRecord = createAsyncThunk(
  'IndianIPL/getBetRecord',
  async (arg, store) => {
    const {offset, more} = store.getState().IndianIPL.betRecordsData
    if (!more) {
      return Promise.reject(new Error('没有更多'))
    }
    const resp = await http.post('/live/activity/cricket_bet_records', {
      ...store.getState().env.deviceinfo,
      offset,
      pageSize: 20,
    })
    return resp.data
  }
)
export const IndianIPLSlice = createSlice({
  name: 'IndianIPL',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomePageData.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const ret: any = {
        homePageData: data.list || [],
        currentGameId: data.current_game_id,
      }
      // id > 0的情况下才去找 有的话获取这个list中的index 可能是 >=0
      const curIdx =
        data.current_game_id > 0
          ? data.list.findIndex((v) => v.game_id === data.current_game_id)
          : -1
      // 表明有进行中的pk
      if (data.current_game_id > 0 && curIdx >= 0) {
        ret.currentGame = data.list[curIdx]
        // 只有有进行中的PK，并且这个正在进行中的PK的倒计时>0才能进行pk
        if (data.list[curIdx].duration > 0) {
          ret.canBet = true
        }
      }
      Object.assign(state, ret)
    })

    builder.addCase(getRankList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {
        rankPageData: {
          list: data.list || [],
          my_info: data.my_info,
        },
      })
    })

    builder.addCase(getBetRecord.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {
        betRecordsData: {
          list: (state.betRecordsData.list || []).concat(data.list || []),
          my_info: data.my_info,
          offset: data.offset,
          more: data.more,
        },
      })
    })
  },
})
export default IndianIPLSlice.reducer
